import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PARTNER_PORTAL_NOT_AUTHORIZED } from '../Constants/partnerRoutes';
import { usePartnerRoleAccess } from '../Hooks/usePartnerRoleAccess';

const PartnerRouteGuard = ({ children }) => {
  const location = useLocation();
  const access = usePartnerRoleAccess();

  if (!access.hasAccess) {
    return <Navigate to={PARTNER_PORTAL_NOT_AUTHORIZED} replace />;
  }

  if (!access.canAccessPath(location.pathname)) {
    return <Navigate to={PARTNER_PORTAL_NOT_AUTHORIZED} replace />;
  }

  return children;
};

export default PartnerRouteGuard;
